export default __webpack_public_path__ + "static/media/blog-img235.2d934d2e.jpg";